import books from "./books.json";
import form from "./form.json";

const book = {
    books: books,
    form: form,
};

export default book;
